import { Bar, mixins } from 'vue-chartjs'
import { debuglog } from 'util';
const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ['options', 'plugin'],
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
    if(this.plugin === true){
       this.addPlugin({
           id: 'mydraw',
           afterDatasetsDraw: function (chart) {
               var ctx = chart.ctx;

               chart.data.datasets.forEach(function (dataset, i) {
                   var meta = chart.getDatasetMeta(i);
                   if (!meta.hidden && i % 2) {
                       meta.data.forEach(function (element, index) {
                           // Draw the text in black, with the specified font
                           ctx.fillStyle = 'rgb(0, 0, 0)';

                           var fontSize = 13;
                           var fontStyle = 'normal';
                           var fontFamily = 'Roboto';
                           ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);

                           // Just naively convert to string for now
                           var dataString = dataset.extra[index].toString();

                           // Make sure alignment settings are correct
                           ctx.textAlign = 'center';
                           ctx.textBaseline = 'middle';

                           var padding = 1;
                           var position = element.tooltipPosition();
                           ctx.fillText(dataString, position.x, position.y - (fontSize / 2) - padding);
                       });
                   }
               });
           }
       })
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/common/Charts/Bar.js